import { palette } from '../../../components/CustomThemeProvider/themes/palette';

export const styles = {
  borderColor: palette.lightGreen,
};
